const ASSET_HOST = 'https://assets.auxodev.dk';

export function isAssetUrl(url) {
  return typeof url === 'string' && url.startsWith(ASSET_HOST) && !url.includes('/cdn-cgi/image/');
}

export function assetUrl(url, width = 1200, quality = 80) {
  if (!isAssetUrl(url)) return url;

  const parsed = new URL(url);
  return `${parsed.origin}/cdn-cgi/image/width=${width},quality=${quality},format=auto${parsed.pathname}`;
}

export function assetSrcSet(url, widths = [400, 800, 1200], quality = 80) {
  if (!isAssetUrl(url)) return undefined;
  return widths.map((width) => `${assetUrl(url, width, quality)} ${width}w`).join(', ');
}

export function assetBackgroundStyle(url, width = 1600, quality = 80) {
  if (!url) return undefined;
  return { backgroundImage: `url(${assetUrl(url, width, quality)})` };
}
